import { useSelector } from 'react-redux';
import { TransactionItem } from '../../redux/localReports/localReports.proptype';
import { selectTransactionsListByTradingPartners } from '../../selectors';

export const useTransactionsListByTradingPartners = (): TransactionItem[] => {
  const transactions = useSelector(selectTransactionsListByTradingPartners);

  return transactions;
};
